import {useMemo} from 'react'

import type {AddressWidgetConfig} from '../../types'

type UseSelectionDependentComponentsReturn = {
  /**
   * Текст заголовока для `AddressDrawer`
   */
  headerTitle: string
}

type DescriptionKey = keyof Pick<AddressWidgetConfig, 'selected_description' | 'unselected_description'>

/**
 * Хук, возвращающий набор компонентов, контент которых зависит от того, выбран ли адрес внутри виджета `AddressWidget`
 * @param isAddressSelected Выбран ли адрес
 * @param addressWidgetConfig конфигурация виджета `AddressWidget`
 * @returns
 */
export const useSelectionDependentComponents = (
  isAddressSelected: boolean,
  addressWidgetConfig: AddressWidgetConfig,
): UseSelectionDependentComponentsReturn => {
  const descriptionKey = useMemo<DescriptionKey>(
    () => (isAddressSelected ? 'selected_description' : 'unselected_description'),
    [isAddressSelected],
  )
  const headerTitle = useMemo(
    () => addressWidgetConfig[descriptionKey].items[0].text,
    [addressWidgetConfig, descriptionKey],
  )

  return {headerTitle}
}
